import { useLifecycle } from '~/hooks/useLifecycle';
import { useStoreActions } from '../store';
import { useSessionStorage } from 'usehooks-ts';

export const Logout = () => {
  const logoutSso = useStoreActions((actions) => actions.session.logoutSso);
  const [, setReturnUrl] = useSessionStorage('returnUrl', '');

  useLifecycle({
    onMount: () => {
      setReturnUrl('');
      logoutSso();
    },
  });

  return <div></div>;
};

export default Logout;
